import { useState, memo } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import styles from './SiteVisitFilters.module.css';

function CheckboxItem({ name, value, checked, onChange, children }) {
  return (
    <label className="d-flex align-items-center gap-1" style={{ cursor: 'pointer' }}>
      <input
        type="checkbox"
        name={name}
        value={value}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span>{children}</span>
    </label>
  );
}

export default memo(function SiteVisitFilters({
  sites,
  schedules,
  nameForSites,
  selectedSiteIds,
  selectedScheduleIds,
  onFilterChange,
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="d-flex gap-2 w-100">
      <div className="collapsible-section w-100 border rounded">
        <button
          type="button"
          className="btn w-100 text-start d-flex justify-content-between align-items-center"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span>Filter {nameForSites} and Visits</span>
          {isOpen
            ? <ChevronUp size={16} strokeWidth={2} aria-hidden />
            : <ChevronDown size={16} strokeWidth={2} aria-hidden />}
        </button>
        {isOpen && (
          <div className="d-flex w-100 p-2">
            <div className={`${styles.half} pe-3 border-end`}>
              <div className="d-flex justify-content-between">
                <strong>{nameForSites}</strong>
                <div className="d-flex gap-2">
                  <button type="button" className="btn btn-link btn-xs p-0" onClick={() => onFilterChange('site', 0, true)}>All</button>
                  <button type="button" className="btn btn-link btn-xs p-0" onClick={() => onFilterChange('site', 0, false)}>None</button>
                </div>
              </div>
              <div className={`${styles.checkboxGrid} border-top ps-1 pt-2`}>
                {sites.map((site) => (
                  <div key={site.id}>
                    <CheckboxItem
                      name={`filter-sites-${site.id}`}
                      value={site.id.toString()}
                      checked={selectedSiteIds.has(site.id)}
                      onChange={(checked) => onFilterChange('site', site.id, checked)}
                    >
                      {site.name}
                    </CheckboxItem>
                  </div>
                ))}
              </div>
            </div>
            <div className={`${styles.half} ps-3`}>
              <div className="d-flex justify-content-between">
                <strong>Visits</strong>
                <div className="d-flex gap-2">
                  <button type="button" className="btn btn-link btn-xs p-0" onClick={() => onFilterChange('schedule', 0, true)}>All</button>
                  <button type="button" className="btn btn-link btn-xs p-0" onClick={() => onFilterChange('schedule', 0, false)}>None</button>
                </div>
              </div>
              <div className={`${styles.checkboxGrid} border-top ps-1 pt-2`}>
                {schedules.map((schedule) => (
                  <div key={schedule.id}>
                    <CheckboxItem
                      name={`filter-schedule-${schedule.id}`}
                      value={schedule.id.toString()}
                      checked={selectedScheduleIds.has(schedule.id)}
                      onChange={(checked) => onFilterChange('schedule', schedule.id, checked)}
                    >
                      {schedule.name}
                    </CheckboxItem>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
});
